import React from 'react';
import { Wrapper } from './FormField.styles';

const FormField = ({ children}: { children: any}) => {
    return <Wrapper className='form-field'>{children}</Wrapper>
}

export default FormField;
